export default __webpack_public_path__ + "static/media/wallet-icon-black.bdbc7284.svg";